import { render, staticRenderFns } from "./DetailBanner.vue?vue&type=template&id=c2c5513a"
import script from "./DetailBanner.vue?vue&type=script&lang=js"
export * from "./DetailBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports